export const trackByIndexFn = (i: number): number => i;


export const trackByIdFn = (i: number, item: any) => item?.id ?? null;
